import { render, staticRenderFns } from "./Vacations.vue?vue&type=template&id=f122299a"
import script from "./Vacations.vue?vue&type=script&lang=js"
export * from "./Vacations.vue?vue&type=script&lang=js"
import style0 from "./Vacations.vue?vue&type=style&index=0&id=f122299a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports